import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useAsyncDebounce,
  usePagination,
  useSortBy,
} from "react-table";
import { FaSearch } from "react-icons/fa";
import { HiRefresh } from "react-icons/hi";
import "../css/makeTable.css";
import Select from "react-select";
import { getData, postData } from "../store/utils";
import Loader from "../component/Loader";
import Modal from "react-modal";
import { FaRegTimesCircle } from "react-icons/fa";
import InventoryModalForm from "./InventoryModalForm";
import InventoryTable from "./InventoryTable";
import Swal from "sweetalert2";
import Table from "../pages/ReactTable"
import { FaEdit } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "none",
    padding: "0px",
    minWidth: "90%",
    maxWidth: "90%",
  },
};

function InventoryList() {
  const userRole = localStorage.getItem("USER_ROLE");
  const [merchantUserData, setMerchantUserData] = useState([]);
  const [selectedOptionStatus, setSelectedOptionStatus] = useState(null);
  const [merchantRefrenceType, setMerchantRefrenceType] = useState();
  const [searchFilters, setSearchFilters] = useState(null);
  const [searchBoxValue, setSearchBoxValue] = useState("");
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageIndex, setPageIndex] = useState(0); // Page index starts from 0
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [errorMessage, setErrorMessage] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const warehouseId = queryParams.get('warehouseId');
  const brandId = queryParams.get('brandId');

  const handleInputChange = (e) => {
    setSearchBoxValue(e.target.value);
  };
  const inputRef = useRef();

  const statusModalOpen = useCallback((rowData) => {
    setSelectedRow(rowData);
    setIsOpen(true);
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  const resetFilters = () => {
    inputRef.current.value = "";
    setMerchantRefrenceType("");
    setSearchBoxValue("");
    updateOrderStatus();
    setSelectedOptionStatus(null);
  };

  // const searchManualData = async () => {
  //   let filterData = {};
  //   if (searchBoxValue) {
  //     if (merchantRefrenceType === "brandName") {
  //       filterData = { brand: searchBoxValue };
  //     } else if (merchantRefrenceType === "productName") {
  //       filterData = { productName: searchBoxValue };
  //     } else {
  //       filterData = { [merchantRefrenceType]: searchBoxValue };
  //     }
  //     filterData.pageSize = 10;
  //     filterData.page = 1;
  //   }

  //   setIsLoadingOn(true);

  //   const queryParams = new URLSearchParams(filterData).toString();

  //   const tempData = await getData(`warehouse/getInventoryDetails?${queryParams}`);

  //   setIsLoadingOn(false);

  //   if (tempData.statusCode === 200) {
  //     setMerchantUserData(tempData?.data?.data || []);
  //   }
  // };

  const searchManualData = () => {
    if (!searchBoxValue) return;

    let filterData = {};
    if (merchantRefrenceType === "brandName") {
      filterData = { brand: searchBoxValue };
    } else if (merchantRefrenceType === "productName") {
      filterData = { productName: searchBoxValue };
    } else {
      filterData = { [merchantRefrenceType]: searchBoxValue };
    } 

    setSearchFilters(filterData); // Store filters
    fetchInventoryData(pageIndex + 1, pageSize, filterData);
  };

  const fetchInventoryData = async (page = 1, pageSize = 10, filters = {}, sortBy = "", orderBy = "") => {
    setIsLoadingOn(true);

    let queryParams = {
      page,
      pageSize,
      ...filters,
    };

    if (sortBy && orderBy) {
      queryParams.sortBy = sortBy;
      queryParams.orderBy = orderBy;
    }

    const url = `warehouse/getInventoryDetails?warehouseId=${warehouseId}&brandId=${brandId}&${new URLSearchParams(queryParams).toString()}`;
    const tempData = await getData(url);

    setIsLoadingOn(false);

    if (tempData.statusCode === 200) {
      // const inventory = tempData.data?.data || []; // fallback to empty array
      const inventoryList = tempData.data?.data || [];
      const pagination = tempData.data?.pagination;

      setMerchantUserData(inventoryList);
      setPageCount(pagination?.totalPagesCount || 0);
      setTotalRecords(pagination?.totalRecords || 0);
      setErrorMessage("");
    } else {
      Swal.fire({
        title: "Error!",
        text: tempData?.data?.errors?.msg || "Something went wrong!!!"
      });
    }
  };

  // const updateOrderStatus = async () => {
  //   setIsLoadingOn(true);
  //   const tempData = await getData("warehouse/getInventoryDetails");
  //   setIsLoadingOn(false);
  //   if (tempData.statusCode == 200) {
  //     setMerchantUserData(tempData?.data?.data || []);
  //   }
  // };

  // useEffect(() => {
  //   updateOrderStatus();
  // }, []);

  // async function updateOrderStatus(page = 0, pageSize = 10, sortBy = "", orderBy = "") {
  //   setIsLoadingOn(true);
  //   let apiUrl = `warehouse/getInventoryDetails?page=${page + 1}&pageSize=${pageSize}`;


  //   if (sortBy && orderBy) {
  //     apiUrl += `&sortBy=${sortBy}&orderBy=${orderBy}`;
  //   }
  //   const tempData = await getData(apiUrl, {})
  //   setIsLoadingOn(false);
  //   if (tempData.statusCode == 200) {
  //     setMerchantUserData(tempData.data.data);
  //     setPageCount(tempData.data.pagination.totalPagesCount);
  //     setTotalRecords(tempData.data.pagination.totalRecords);
  //     setErrorMessage("");
  //   }
  //   else {
  //     Swal.fire({
  //       title: "Error!",
  //       text: tempData?.data?.errors.msg || "Something went wrong!!!"
  //     })
  //   }
  // }

  const updateOrderStatus = (page = 0, pageSize = 10, sortBy = "", orderBy = "") => {
    fetchInventoryData(page + 1, pageSize, searchFilters || {}, sortBy, orderBy);
  };

  useEffect(() => {
    updateOrderStatus(pageIndex, pageSize, sortBy, orderBy);
  }, [pageIndex, pageSize, sortBy, orderBy]);


  // useEffect(() => {
  //   updateOrderStatus(pageIndex, pageSize, sortBy, orderBy);
  // }, [pageIndex, pageSize, sortBy, orderBy]);


  const columns = useMemo(
    () => [
      {
        Header: "Warehouse Name",
        accessor: "warehouseName",
      },
      {
        Header: "Product Name",
        accessor: "productName",
      },
      {
        Header: "Quantity",
        accessor: "quantity",
      },
      {
        Header: "Color",
        accessor: "color",
      },
      {
        Header: "Brand",
        accessor: "brand",
      },
      {
        Header: "Distributor Shop Name",
        accessor: "shopName",
      },
      {
        Header: "Product Id",
        accessor: "productId",
      },
      {
        Header: "Inventory Id",
        accessor: "inventoryId",
      },
      {
        Header: "Distributor Id",
        accessor: "distributorId",
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => {
          return (
            <button
              onClick={() => statusModalOpen(row.original)}
              className="editButtonSet"
            >
              <FaEdit />
            </button>
          );
        },
      },
    ],
    [statusModalOpen]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    // state: { pageIndex },
  } = useTable(
    {
      columns,
      data: merchantUserData || [],
      initialState: { pageIndex: 0 },
    },
    usePagination
  );

  const handleGotoPage = (page) => {
    if (page < 0 || page >= pageCount) {
      setErrorMessage(`No data to display`);
    } else {
      setErrorMessage("");
      setPageIndex(page);
    }
  };

  const handleSort = (column) => {
    let newOrderBy = "asc";

    if (sortBy === column.id) {
      newOrderBy = orderBy === "asc" ? "desc" : "asc";
    }
    setSortBy(column.id);
    setOrderBy(newOrderBy);
    // merchantGetData(pageIndex, pageSize, column.id, newOrderBy);
  };

  const merchantOption = [
    { value: "warehouseName", label: "Warehouse Name" },
    { value: "brandName", label: "Brand Name" },
    { value: "productName", label: "Product Name" },
  ];

  return (
    <div>
      {isLoadingOn ? <Loader /> : ""}
      <h4 style={{ marginBottom: 10 }}>Inventory List</h4>
      <div className="customHeaderTable" style={{display: "none"}}>
        <div className="container-fluid">
          <div className="row alignmentTable">
            <div className="col-md-2">
              <Select
                placeholder="Select Search"
                name="role"
                options={merchantOption}
                value={selectedOptionStatus}
                onChange={(e) => {
                  setMerchantRefrenceType(e.value);
                  setSelectedOptionStatus(e);
                }}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="searchInputField"
                ref={inputRef}
                onChange={handleInputChange}
                placeholder="Enter Details"
                value={searchBoxValue}
              />
            </div>
            <div className="col-md-2 text-center">
              <button className="searchTableData" onClick={searchManualData}>
                <FaSearch /> Search
              </button>
            </div>

            <div className="col-md-2 text-center" onClick={resetFilters}>
              <button className="resetTableData">
                <HiRefresh /> Reset
              </button>
            </div>
            <div className="col-md-4 d-flex justify-content-end" onClick={resetFilters}>
              <button onClick={statusModalOpen} className="btn btn-success">
                Add Inventory
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="inventoryDataSection">
        {/* {merchantUserData && (
          <InventoryTable
            data={merchantUserData}
            userRole={userRole}
            statusModalOpen={statusModalOpen}
          />
        )} */}

        {merchantUserData.length > 0 ? ( // Only render the table if data is available
          <Table
            columns={columns}
            data={merchantUserData || []}
            pageCount={pageCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
            totalRecords={totalRecords}
            handleGotoPage={handleGotoPage}
            errorMessage={errorMessage}
            handleSort={handleSort}
            sortBy={sortBy}
            orderBy={orderBy}
          />
        ) : (
          <div>No data available</div>
        )}

      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <button className="modalCloseBtn" onClick={closeModal}>
          <FaRegTimesCircle />
        </button>
        {isLoadingOn ? <Loader /> : ""}
        <h4 className="pleaseSelectStatus">{selectedRow?.productId ? "Update Inventory" : "Add Inventory"}</h4>
        <div className="modalUserPaymentStatus">
          <InventoryModalForm
            closeModal={closeModal}
            updateOrderStatus={() => updateOrderStatus()}
            selectedRow={selectedRow}
          />
        </div>
      </Modal>
    </div>
  );
}

export default InventoryList;
